import { filter, map, Observable } from 'rxjs';

export function someAreLoading(input: Observable<boolean[]>) {
  return input.pipe(map(x => x.some(y => y === true)));
}
